
export const environment: any = {
  "hostname": 'cblrd.lexus.com',
  "production":true,
  "baseLoginUrl": "https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/authorize?client_id=2ca97cfa-dd64-4a98-976a-685ade27ee25&response_type=code&redirect_uri=https://cblrd.lexus.com&response_mode=query&scope=openid&state=23343&code_challenge=",
  "tokenURL": "https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/token",
  "logoutUrl": "https://login.microsoftonline.com/common/oauth2/logout",
  "grantType": "authorization_code",
  "clientId": "2ca97cfa-dd64-4a98-976a-685ade27ee25",
  "redirectURI": "https://cblrd.lexus.com",
  "region": "us-east-1",
  "turnOverReport": "https://api.cblrd.lexus.com/dashboard/",
  "aseReport":"https://api.cblrd.lexus.com/ase_reports/",
  "jobEnrollment":"https://api.cblrd.lexus.com/job_enrollment/",
  "dealerTrainingBilling":"https://api.cblrd.lexus.com/dealers_billing/",
  "elevateBilling":"https://api.cblrd.lexus.com/elevate_billing/",
  "eventBilling": "https://api.cblrd.lexus.com/event_billing/",
  "staffMaster":"https://api.cblrd.lexus.com/staff_master/",
  "UserAccess": "https://api.cblrd.lexus.com/access_control/",
  "tenure":"https://api.cblrd.lexus.com/tenure_api/",
  "eventDashboard":"https://api.cblrd.lexus.com/event_dashboard/",
  "eliteCertification":"https://api.cblrd.lexus.com/elite_certification/",
  "impactAnalysis":"https://api.cblrd.lexus.com/impact_analysis/",
  "dealerScorecard":"https://jn7r7nqslg.execute-api.us-west-2.amazonaws.com/dev/"
};

export const applyConfig = (config: any) => {
  Object.assign(environment, config);
};
